import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { generateId } from '@lc/util';

export type ProgressBarAlignment = 'left' | 'center';
export type ProgressBarSize = 'small' | 'large';

@Component({
  selector: 'bspk-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  host: {
    'data-bspk': 'progress-bar',
    '[attr.data-align]': 'align()',
    '[attr.data-size]': 'size()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BspkProgressBar {
  readonly label = input.required<string>();
  readonly progress = input.required<number>();
  readonly align = input<ProgressBarAlignment>('center');
  readonly size = input<ProgressBarSize>('large');
  readonly id = generateId('progress-bar');
}
